export default class UsuarioPermissoes {
  constructor({ usuarioId, perfisId }) {
    this.usuarioId = usuarioId;
    this.perfisId = perfisId;
  }
}
